import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImgResetLink = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 320,
	height: 144,
	viewBox: "0 0 320 144",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 112,
		y: 24,
		width: 96,
		height: 96,
		rx: 48,
		fill: "#F7F7F7"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M136 59.5312V59.25C136.094 56.3438 138.531 54 141.531 54H178.562C181.469 54 183.906 56.3438 184 59.25V84C184 87.2812 181.281 90 178 90H142C138.719 90 136 87.2812 136 84V59.5312ZM181 64.5L164.406 76.5938C161.781 78.5625 158.219 78.5625 155.594 76.5938L139 64.5V84C139 85.6875 140.312 87 142 87H178C179.688 87 181 85.6875 181 84V64.5ZM181 59.5312C181 58.125 179.875 57 178.562 57H141.531C140.125 57 139 58.125 139 59.5312C139 60.2812 139.375 61.0312 140.031 61.5L157.375 74.1562C158.969 75.375 161.125 75.375 162.625 74.1562L179.969 61.5C180.625 61.0312 181 60.2812 181 59.4375V59.5312Z",
		fill: "black"
	})]
});
export default SvgImgResetLink;
